var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scene-overlay-wrapper"},[_c('canvas',{ref:"canvas",attrs:{"id":"portfolio-canvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }